<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('coupon.page_header_edit') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-700 c-form-row">

                    <v-form-row>
                        <v-input v-model="Coupon.Code" name="code" :fluid="true" :error="Validate.Code">
                            <slot slot="label">{{ $t('coupon.label.code') }}</slot>
                        </v-input>
                    </v-form-row>
                    
                    <v-form-row>
                        <v-datepicker v-model="Coupon.From" :available-dates="{ start: null, end: null }" :label="$t('coupon.label.from_date')" :error="Validate.From" :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-datepicker v-model="Coupon.To" :available-dates="{ start: null, end: null }" :label="$t('coupon.label.to_date')" :error="Validate.To" :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="Coupon.ViewType"
                                         v-if="Coupon.ViewType"
                                         :options="TypeOptions"
                                         option-name="Content"
                                         option-value="Value"
                                         name="type"
                                         search-label="Content"
                                         track-by="Value"
                                         :fluid="true"
                                         :multiple="false"
                                         @change="checkSelection">
                                <slot slot="label">{{ $t('coupon.label.type') }}</slot>
                            </v-custom-select>
                    </v-form-row>

                    <v-form-row v-if="canHaveAmounts">
                        <h3 class="u-pull-left">{{ $t('coupon.label.amounts') }}</h3>
                        <div class="u-pull-right">
                            <v-add-coupon-value
                                    v-if="availableCurrencies.length > 0"
                                    @couponValueAdded="addCouponValue"
                                    :couponId="Coupon.Id"
                                    :currencyOptions="availableCurrencies">
                            </v-add-coupon-value>
                        </div>
                        <table-component v-if="Coupon.Values && Coupon.Values.length > 0" class="o-page-row" table-class="c-table c-table--small" :data="Coupon.Values" :show-caption="false" :show-filter="false">
                            <table-column key="CurrencyId" :sortable="false">
                                <template slot-scope="row">
                                    {{ getCurrencyCode(row.CurrencyId) }}
                                </template>
                            </table-column>
                            <table-column key="Value" :label="$t('coupon.label.amount')" :sortable="false">
                                <template slot-scope="row">
                                    {{ getDisplayValue(row.Value, row.CurrencyId) }}
                                </template>
                            </table-column>
                            <table-column cell-class="u-text-nowrap u-text-align-center" :sortable="false">
                                <template slot-scope="row">
                                    <v-edit-coupon-value :coupon-value="row" :currencyCode="getCurrencyCode(row.CurrencyId)" class="edit-coupon-value-button"></v-edit-coupon-value>
                                    <button type="button" class="c-button c-button--tiny c-button--alpha" @click="deleteCouponValue(row.CurrencyId)">
                                        <svgicon name="cross" class="svg-icon svg-fill"></svgicon>
                                    </button>
                                </template>
                            </table-column>
                        </table-component>
                        <div v-else class="u-font-large u-text-align-center u-padding">
                            {{ $t('coupon.label.no_values_found') }}
                        </div>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item u-pull-right">
                            <v-label></v-label>
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('coupon.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>
<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import _find from 'lodash/find'
    import VAddCouponValue from '@/components/coupons/AddCouponValue'
    import VEditCouponValue from '@/components/coupons/EditCouponValue'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VDatepicker,
            VAddCouponValue,
            VEditCouponValue        
        },
        data() {
            return {
                Validate: {},
                loaded: {},
                TypeOptions: [
                    { "Content": this.$t('coupon.types.fixed'), "Value": 0 },
                    { "Content": this.$t('coupon.types.percentage'), "Value": 1 },
                    { "Content": this.$t('coupon.types.free_shipping'), "Value": 2 },
                ]
            }
        },
        computed: {
            ...mapGetters({
                Coupon: 'Coupon',
                CurrencyOptions: 'CurrencyOptions'
            }),
            canHaveAmounts(){
                return this.loaded.isLoaded && this.Coupon.ViewType.Value !== 2
            },
            availableCurrencies(){
                let currencies = [];

                if(this.loaded.isLoaded){
                    this.CurrencyOptions.forEach((item) => {
                        let exists = _find(this.Coupon.Values, {'CurrencyId': item.Id});

                        if(!exists){
                            currencies.push(item);
                        }
                    });
                }
                
                return currencies;
            }
        },
        created: function () {
            this.$store.dispatch('getCurrencyOptions').then(() => {
                this.$store.dispatch('getCoupon', this.$attrs.id).then(() => {
                    this.loaded = { isLoaded: true }
                });
            });
        },
        methods: {
            checkSelection() {
                if(this.Coupon.ViewType.Value === 2){
                    this.Coupon.Values = [];
                }
            },
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}

                this.Coupon.Type = this.Coupon.ViewType ? this.Coupon.ViewType.Value :  null;
                if(this.Coupon.From === 'Invalid date')
                {
                    this.Coupon.From = null;
                }
                if(this.Coupon.To === 'Invalid date')
                {
                    this.Coupon.To = null;
                }

                this.$store.dispatch('updateCoupon', this.Coupon).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'CouponsOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            },
            getDisplayValue(value, currencyId){
                if(this.Coupon.ViewType.Value === 0){
                    return this.$options.filters.currency(value, this.getCurrencySymbol(currencyId));
                }

                if(this.Coupon.ViewType.Value === 1){
                    return value + " %";
                }

                return "";
            },
            getCurrencyCode(currencyId){
                let currency = _find(this.CurrencyOptions, {'Id': currencyId});

                if(currency){
                    return currency.Code;
                }
            },
            getCurrencySymbol(currencyId){
                let currency = _find(this.CurrencyOptions, {'Id': currencyId});

                if(currency){
                    return currency.Symbol;
                }
            },
            addCouponValue(newCouponValue){
                this.Coupon.Values.push(newCouponValue);
            },
            deleteCouponValue(currencyIdToDelete){
                this.Coupon.Values = this.Coupon.Values.filter(function(item){
                    return item.CurrencyId !== currencyIdToDelete;
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/private";
    .edit-coupon-value-button {
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/views/admin/coupons/Edit.vue